var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20809_27541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03216 4.09859C2.85229 4.09859 2.67979 4.17004 2.5526 4.29723C2.42541 4.42442 2.35396 4.59692 2.35396 4.77679V14.2716C2.35396 14.4515 2.42541 14.624 2.5526 14.7512C2.67979 14.8784 2.85229 14.9498 3.03216 14.9498H12.527C12.7068 14.9498 12.8793 14.8784 13.0065 14.7512C13.1337 14.624 13.2052 14.4515 13.2052 14.2716V10.65C13.2052 10.2755 13.5088 9.97181 13.8834 9.97181C14.2579 9.97181 14.5616 10.2755 14.5616 10.65V14.2716C14.5616 14.8112 14.3472 15.3287 13.9657 15.7103C13.5841 16.0918 13.0666 16.3062 12.527 16.3062H3.03216C2.49255 16.3062 1.97504 16.0918 1.59348 15.7103C1.21192 15.3287 0.997559 14.8112 0.997559 14.2716V4.77679C0.997559 4.23718 1.21192 3.71967 1.59348 3.33811C1.97504 2.95655 2.49255 2.74219 3.03216 2.74219H6.65376C7.02832 2.74219 7.33196 3.04583 7.33196 3.42039C7.33196 3.79495 7.02832 4.09859 6.65376 4.09859H3.03216Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0475 1.58145C12.3124 1.3166 12.7418 1.3166 13.0067 1.58145L15.7195 4.29426C15.9843 4.55911 15.9843 4.98852 15.7195 5.25338L8.93746 12.0354C8.81027 12.1626 8.63777 12.234 8.4579 12.234H5.7451C5.37054 12.234 5.06689 11.9304 5.06689 11.5558V8.84302C5.06689 8.66315 5.13835 8.49065 5.26554 8.36346L12.0475 1.58145ZM6.4233 9.12394V10.8776H8.17698L14.2808 4.77382L12.5271 3.02013L6.4233 9.12394Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20809_27541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2768,
    height: 16.2768,
    fill: "white",
    transform: "translate(0.319336 0.703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.b9a5988ec551422709a203d5156729eb.svg";
export { ForwardRef as ReactComponent };